import Promise from 'bluebird';
import cookie from 'cookie-cutter';

const SWID_RE = /^\{[\w-]+\}/;

export const START_CHECK_ONEID_AUTHENTICATION = 'START_CHECK_ONEID_AUTHENTICATION';
export const COMPLETE_CHECK_ONEID_AUTHENTICATION = 'COMPLETE_CHECK_ONEID_AUTHENTICATION';

export function startOneIdAuthentication() {
    return {
        type: START_CHECK_ONEID_AUTHENTICATION,
        startTime: Date.now()
    };
}

export function completeOneIdAuthentication(isAuthenticated, swid) {
    return {
        type: COMPLETE_CHECK_ONEID_AUTHENTICATION,
        isAuthenticated,
        swid,
        completeTime: Date.now()
    };
}

// TODO: Maybe swid should come from some OneId library instead of the cookie
export function checkOneIdAuthentication() {
    return (dispatch) => {
        dispatch(startOneIdAuthentication());
        const swid = cookie.get('SWID');
        const isAuthenticated = SWID_RE.test(swid);

        dispatch(completeOneIdAuthentication(isAuthenticated, swid));
        return Promise.resolve(isAuthenticated);
    };
}



// WEBPACK FOOTER //
// ./app/common/actions/oneIdActions.js